import React, { useState, useRef } from 'react';
import '../App.css';

function Login() {
  const [email, setEmail] = useState('');
  const [googleSubmitting, setGoogleSubmitting] = useState(false);
  const [emailSubmitting, setEmailSubmitting] = useState(false);
  const [showBanner, setShowBanner] = useState(false);
  const [validationError, setValidationError] = useState('');
  const emailInputRef = useRef(null);

  const onSubmit = () => {
    if (!email.trim()) {
      // Show validation message and focus input
      setValidationError('Please enter a valid email address');
      if (emailInputRef.current) {
        emailInputRef.current.focus();
      }
      return;
    }
    
    // Clear any previous validation error
    setValidationError('');
    setEmailSubmitting(true);
    setShowBanner(false);
    setTimeout(() => {
      setEmailSubmitting(false);
      setShowBanner(true);
    }, 30000);
  };

  const onGoogleSubmit = () => {
    setGoogleSubmitting(true);
    setShowBanner(false);
    setTimeout(() => {
      setGoogleSubmitting(false);
      setShowBanner(true);
    }, 10000);
  };

  return (
    <div className="App">
      <div className="fullscreen-section-content">
        <div className="container-login align-content-center">
          <div className="row align-items-center">
            <div className="col-12">
              <div className="container">
                <div className="row">
                  <div className="col-md-6">
                    <div className="register-leftSide mt-5">
                      <div className="register-placeholder">
                        <div className="reg-img">
                          <img src={`${process.env.PUBLIC_URL || ''}/assets/vumu/VUMUloginImage.jpg`} alt="Login Banner" />
                        </div>
                        <div className="reg-img-lead">
                          <label>Jake:</label>
                          <p>Man! this tool is awesome. It literally saves an insane amount of time 🔥</p>
                        </div>
                        <div className="dummy-placeHolder"> </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="register-rightSide">
                      <div className="logo-lead">
                        <img src={`${process.env.PUBLIC_URL || ''}/assets/vumu/vumuLogoLead.png`} alt="vumu" />
                      </div>
                      <div className="register-form">
                        <button type="button" className="google-btn" onClick={onGoogleSubmit} disabled={googleSubmitting}>
                          <svg width="18" height="18" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path fill="#FFC107" d="M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12 s5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C33.64,6.053,29.084,4,24,4C12.955,4,4,12.955,4,24 s8.955,20,20,20s20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z"/><path fill="#FF3D00" d="M6.306,14.691l6.571,4.819C14.655,16.108,18.961,14,24,14c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657 C33.64,6.053,29.084,4,24,4C16.318,4,9.656,8.337,6.306,14.691z"/><path fill="#4CAF50" d="M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36 c-5.202,0-9.623-3.319-11.283-7.955l-6.49,5.005C9.505,39.556,16.227,44,24,44z"/><path fill="#1976D2" d="M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.094,5.571 c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z"/></svg>
                          {googleSubmitting ? 'Please wait…' : 'Sign up with Gmail?'}
                        </button>
                        <div className="form-group">
                          <span className="label">Email address</span>
                          <input
                            ref={emailInputRef}
                            className="input"
                            type="email"
                            value={email}
                            onChange={(e) => {
                              setEmail(e.target.value);
                              // Clear validation error when user starts typing
                              if (validationError) {
                                setValidationError('');
                              }
                            }}
                            placeholder="Enter email"
                            disabled={emailSubmitting}
                          />
                          {validationError && (
                            <div style={{ color: '#dc3545', fontSize: '12px', marginTop: '4px' }}>
                              {validationError}
                            </div>
                          )}
                        </div>
                        <button type="button" className="btn-primary" onClick={onSubmit} disabled={emailSubmitting}>
                          {emailSubmitting ? (
                            <>
                              <div className="spinner"></div>
                              Continue with email
                            </>
                          ) : 'Continue with email'}
                        </button>
                        {showBanner && (
                          <div className="maintenance-banner" role="status">
                             It seems there’s a technical issue. Please contact us at <a href="#">support@vumu.io</a>
                             {" "} for assistance.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
